import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "page-wrap" }
const _hoisted_2 = { class: "page-bar" }
const _hoisted_3 = { style: {"display":"flex"} }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "thl-head" }
const _hoisted_7 = ["onUpdate:modelValue"]
const _hoisted_8 = ["aria-label", "onClick"]
const _hoisted_9 = { class: "thl-row" }
const _hoisted_10 = ["onUpdate:modelValue"]
const _hoisted_11 = ["onUpdate:modelValue"]
const _hoisted_12 = ["onUpdate:modelValue", "onInput"]
const _hoisted_13 = { class: "chip-editor-item-opts thl-locs" }
const _hoisted_14 = ["onUpdate:modelValue"]
const _hoisted_15 = {
  key: 0,
  class: "settings-desc"
}
const _hoisted_16 = { class: "btn-row settings-save" }
const _hoisted_17 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_drop_file = _resolveComponent("drop-file")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_settings_layout = _resolveComponent("settings-layout")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[3] || (_cache[3] = _createElementVNode("div", null, [
        _createElementVNode("div", { class: "page-bar-sub" }, "Settings"),
        _createElementVNode("div", { class: "page-bar-main" }, "Edit Links")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          onClick: _cache[0] || (_cache[0] = () => { _ctx.editMode = !_ctx.editMode }),
          class: "add-btn",
          style: {"margin":"0"}
        }, [
          (_ctx.editMode)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, "Close Edit Mode"))
            : (_openBlock(), _createElementBlock("span", _hoisted_5, "Edit Mode"))
        ])
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$store.state.routeLoaded ? 'slide-up view' : 'hide')
    }, [
      _createVNode(_component_settings_layout, { desc: "Links appear in the navigation menu in the Docs & Links section. Turn on Edit Mode to change them; drag a link by its handle to reorder." }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: "form-wrapper settings-form",
            style: _normalizeStyle(_ctx.editMode ? '' : 'pointer-events:none')
          }, [
            _createVNode(_component_draggable, {
              list: _ctx.formData.teamHubLinks,
              handle: ".crm-checklist-handle",
              animation: 150,
              "ghost-class": "kanban-ghost"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formData.teamHubLinks, (link, i) => {
                  return (_openBlock(), _createElementBlock("section", {
                    key: i,
                    class: _normalizeClass(['settings-card', 'thl-card', { 'thl-locked': !_ctx.editMode }])
                  }, [
                    _createElementVNode("div", _hoisted_6, [
                      _cache[4] || (_cache[4] = _createElementVNode("span", {
                        class: "crm-checklist-handle",
                        title: "Drag to reorder",
                        "aria-hidden": "true"
                      }, "⋮⋮", -1)),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        "onUpdate:modelValue": ($event: any) => ((link.name) = $event),
                        class: "thl-name",
                        placeholder: "Link Name",
                        "aria-label": "Link name"
                      }, null, 8, _hoisted_7), [
                        [_vModelText, link.name]
                      ]),
                      _createElementVNode("button", {
                        type: "button",
                        class: "form-close-x",
                        title: "Remove link",
                        "aria-label": 'Remove ' + (link.name || 'link'),
                        onClick: ($event: any) => (_ctx.removeLink(i))
                      }, "×", 8, _hoisted_8)
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("label", null, [
                        _cache[6] || (_cache[6] = _createElementVNode("span", { class: "thl-label" }, "Type", -1)),
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": ($event: any) => ((link.type) = $event)
                        }, [...(_cache[5] || (_cache[5] = [
                          _createElementVNode("option", { value: "embed" }, "Embedded Pop Up", -1),
                          _createElementVNode("option", { value: "internal" }, "Page Link", -1),
                          _createElementVNode("option", { value: "newtab" }, "External Link", -1),
                          _createElementVNode("option", { value: "table" }, "Sheet", -1)
                        ]))], 8, _hoisted_10), [
                          [_vModelSelect, link.type]
                        ])
                      ]),
                      _createElementVNode("label", null, [
                        _cache[8] || (_cache[8] = _createElementVNode("span", { class: "thl-label" }, "Who sees it", -1)),
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": ($event: any) => ((link.userType) = $event)
                        }, [...(_cache[7] || (_cache[7] = [
                          _createElementVNode("option", { value: undefined }, "All Users", -1),
                          _createElementVNode("option", { value: "nopublicusers" }, "No Standard Users", -1),
                          _createElementVNode("option", { value: "teamhubadminonly" }, "Team Hub Admin Only", -1)
                        ]))], 8, _hoisted_11), [
                          [_vModelSelect, link.userType]
                        ])
                      ])
                    ]),
                    (link.type != 'table')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createElementVNode("label", null, [
                            _cache[9] || (_cache[9] = _createElementVNode("span", { class: "thl-label" }, "Link URL", -1)),
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              "onUpdate:modelValue": ($event: any) => ((link.link) = $event),
                              placeholder: "https://...",
                              onInput: ($event: any) => (_ctx.checkLink(link))
                            }, null, 40, _hoisted_12), [
                              [_vModelText, link.link]
                            ])
                          ]),
                          _createVNode(_component_drop_file, {
                            onFileChange: ($event: any) => (_ctx.onFileChange($event, link)),
                            class: "slim-drop-file thl-file"
                          }, null, 8, ["onFileChange"])
                        ], 64))
                      : _createCommentVNode("", true),
                    _cache[10] || (_cache[10] = _createElementVNode("div", { class: "thl-label" }, "Locations", -1)),
                    _createElementVNode("div", _hoisted_13, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$store.state.user.locations, (loc, j) => {
                        return (_openBlock(), _createElementBlock("label", {
                          key: 'l'+j,
                          class: "checkbox-input"
                        }, [
                          _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            "onUpdate:modelValue": ($event: any) => ((link.locations[loc]) = $event)
                          }, null, 8, _hoisted_14), [
                            [_vModelCheckbox, link.locations[loc]]
                          ]),
                          _createElementVNode("span", null, _toDisplayString(loc), 1)
                        ]))
                      }), 128))
                    ])
                  ], 2))
                }), 128))
              ]),
              _: 1
            }, 8, ["list"]),
            (!_ctx.formData.teamHubLinks.length)
              ? (_openBlock(), _createElementBlock("p", _hoisted_15, "No links yet."))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("button", {
                type: "button",
                class: "btn-lg btn-light",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.addLink()))
              }, "Add Link"),
              _createElementVNode("button", {
                type: "button",
                class: "btn-lg",
                disabled: _ctx.disableButton,
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.submit()))
              }, "Save Changes", 8, _hoisted_17)
            ])
          ], 4)
        ]),
        _: 1
      })
    ], 2)
  ]))
}